export const chargeTypes = new Set(["Charge", "Refund"]);
export const paymentTypes = new Set([
  "Financial Aid",
  "Payment",
  "Adjustment",
  "Deposit",
]);
